import {
    Header,
    RowValue,
    TableRowBase,
} from 'bam-node-savant-table/table-ts.ts'
import { guff } from './guff'

export default function displayFn<Data extends TableRowBase>(
    val: RowValue,
    _: unknown,
    { field }: Header<Data>
) {
    if (typeof field !== 'string') {
        throw new Error("Can't use `displayFn` with function fields")
    }
    return guff(val, field)
}
